import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import {
  FDCardContent, FDDisplayText, FDIcon, FDLabelText, FDPaper, FDSecondaryActionButton, FDStack, FDTooltip,
} from '@facet-wealth/design';
import { AccordionCategoryList } from 'Components/ComponentLibrary/Organisms/AccordionCategoryList';
import { CashFlowItem } from 'Views/Page/Content/Templates/CashFlowPageTemplate/CashFlowItem';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { dataAttrs } from 'Helpers/Testing';

export const CashFlowCategorySection = ({
  sectionResource,
  onEditItemClick,
}) => {
  const { loadModalCollectionByLink } = useModalContext();

  const onEditCategoryClick = (rel) => () => loadModalCollectionByLink(rel.link('related').url());

  return (
    <FDStack direction="column" spacing={3} width="100%" flex={1}>
      <FDStack justifyContent="space-between" alignItems="center">
        <FDStack direction="column">
          <FDLabelText size="lg" value={sectionResource.selectedOptionPrompt('sectionName')} color="textSecondary" />
          <FDStack direction={'row'}>
            <FDDisplayText size="sm" value={sectionResource.attr('total')} data-test={`${sectionResource.attr('sectionName')}-total`} />
            {sectionResource.attr('description') && (
              <FDTooltip title={sectionResource.attr('description')}>
                <FDIcon
                  color="primary"
                  icon="info"
                  size="sm"
                />
              </FDTooltip>
            )}
          </FDStack>
        </FDStack>
        {sectionResource.withRelationship(
          fr.relationships.addWizard.name,
          (rel) => (
            <FDSecondaryActionButton
              {...dataAttrs('add-wizard')}
              label={rel.meta('prompt')}
              size="sm"
              onClick={() => loadModalCollectionByLink(rel.link('related').url())}
            />
          ),
          () => null,
        )}
      </FDStack>
      <FDPaper width={'100%'} appearance={'elevated'}>
        <FDCardContent>
          <AccordionCategoryList
            ListItemComponent={CashFlowItem}
            onEditCategoryClick={onEditCategoryClick}
            categoriesCollection={sectionResource.attr('categories')}
            onEditLineItemClick={onEditItemClick}
            emptyTitle={sectionResource.attr('emptyStateHeader')}
            emptyDescription={`Add your ${sectionResource.selectedOptionPrompt('sectionName').toLowerCase()} to start seeing your full financial picture.`}
          />
        </FDCardContent>
      </FDPaper>
    </FDStack>
  );
};

CashFlowCategorySection.propTypes = {
  sectionResource: PropTypes.object.isRequired,
  onEditItemClick: PropTypes.func.isRequired,
};
